import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import GeometryFactory from '../geom/GeometryFactory';
import RobustLineIntersector from '../algorithm/RobustLineIntersector';
import RuntimeException from '../../../../java/lang/RuntimeException';
var NodingValidator = /*#__PURE__*/function () {
  function NodingValidator() {
    _classCallCheck(this, NodingValidator);
    NodingValidator.constructor_.apply(this, arguments);
  }
  _createClass(NodingValidator, [{
    key: "checkEndPtVertexIntersections",
    value: function checkEndPtVertexIntersections() {
      if (arguments.length === 0) {
        for (var i = this._segStrings.iterator(); i.hasNext();) {
          var ss = i.next();
          var pts = ss.getCoordinates();
          this.checkEndPtVertexIntersections(pts[0], this._segStrings);
          this.checkEndPtVertexIntersections(pts[pts.length - 1], this._segStrings);
        }
      } else if (arguments.length === 2) {
        var testPt = arguments[0],
          segStrings = arguments[1];
        for (var _i = segStrings.iterator(); _i.hasNext();) {
          var _ss = _i.next();
          var _pts = _ss.getCoordinates();
          for (var j = 1; j < _pts.length - 1; j++) if (_pts[j].equals(testPt)) throw new RuntimeException('found endpt/interior pt intersection at index ' + j + ' :pt ' + testPt);
        }
      }
    }
  }, {
    key: "checkInteriorIntersections",
    value: function checkInteriorIntersections() {
      if (arguments.length === 0) {
        for (var i = this._segStrings.iterator(); i.hasNext();) {
          var ss0 = i.next();
          for (var j = this._segStrings.iterator(); j.hasNext();) {
            var ss1 = j.next();
            this.checkInteriorIntersections(ss0, ss1);
          }
        }
      } else if (arguments.length === 2) {
        var _ss2 = arguments[0],
          _ss3 = arguments[1];
        var pts0 = _ss2.getCoordinates();
        var pts1 = _ss3.getCoordinates();
        for (var i0 = 0; i0 < pts0.length - 1; i0++) for (var i1 = 0; i1 < pts1.length - 1; i1++) this.checkInteriorIntersections(_ss2, i0, _ss3, i1);
      } else if (arguments.length === 4) {
        var e0 = arguments[0],
          segIndex0 = arguments[1],
          e1 = arguments[2],
          segIndex1 = arguments[3];
        if (e0 === e1 && segIndex0 === segIndex1) return null;
        var p00 = e0.getCoordinates()[segIndex0];
        var p01 = e0.getCoordinates()[segIndex0 + 1];
        var p10 = e1.getCoordinates()[segIndex1];
        var p11 = e1.getCoordinates()[segIndex1 + 1];
        this._li.computeIntersection(p00, p01, p10, p11);
        if (this._li.hasIntersection()) if (this._li.isProper() || this.hasInteriorIntersection(this._li, p00, p01) || this.hasInteriorIntersection(this._li, p10, p11)) throw new RuntimeException('found non-noded intersection at ' + p00 + '-' + p01 + ' and ' + p10 + '-' + p11);
      }
    }
  }, {
    key: "checkValid",
    value: function checkValid() {
      this.checkEndPtVertexIntersections();
      this.checkInteriorIntersections();
      this.checkCollapses();
    }
  }, {
    key: "checkCollapses",
    value: function checkCollapses() {
      if (arguments.length === 0) {
        for (var i = this._segStrings.iterator(); i.hasNext();) {
          var ss = i.next();
          this.checkCollapses(ss);
        }
      } else if (arguments.length === 1) {
        var _ss4 = arguments[0];
        var pts = _ss4.getCoordinates();
        for (var _i2 = 0; _i2 < pts.length - 2; _i2++) this.checkCollapse(pts[_i2], pts[_i2 + 1], pts[_i2 + 2]);
      }
    }
  }, {
    key: "hasInteriorIntersection",
    value: function hasInteriorIntersection(li, p0, p1) {
      for (var i = 0; i < li.getIntersectionNum(); i++) {
        var intPt = li.getIntersection(i);
        if (!(intPt.equals(p0) || intPt.equals(p1))) return true;
      }
      return false;
    }
  }, {
    key: "checkCollapse",
    value: function checkCollapse(p0, p1, p2) {
      if (p0.equals(p2)) throw new RuntimeException('found non-noded collapse at ' + NodingValidator.fact.createLineString([p0, p1, p2]));
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._li = new RobustLineIntersector();
      this._segStrings = null;
      var segStrings = arguments[0];
      this._segStrings = segStrings;
    }
  }]);
  return NodingValidator;
}();
export { NodingValidator as default };
NodingValidator.fact = new GeometryFactory();